/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />
/// <reference path="../../components/baseclasses/dataMaintenanceContextBase.ts" />

module Meevo.Plugins.AddOnGroup {
    "use strict";

    export class AddOnGroupContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        public businessTypeFilter = {
            includeAllBusinessTypeListItem: true,
            coSearchType: Meevo.Model.CoSearchType.CentralOffice,
            coSearchResultFilter: Meevo.Model.CoSearchResultsFilter.LocationOverrides
        };

        constructor(
            appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $q: angular.IQService
        ) {
            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, null, false);
            this.baseEndpoint = appSettings.API_ENDPOINTS.addOnGroup;
            this.sectionTemplatePath = 'app/plugins/addOnGroup/sectionViews/';
            this.entityType = 'AddOnGroup';
            this.buildCrudSecurityKeys(this.securityKeys.DATA_ADDONGROUP_TAB_MAIN);
            this.initializeSections();
        }

        initializeSections(): void {
            let baseSectionProps: Meevo.Model.ISectionParamsBaseDataService = {
                sectionId: 0,
                displayNameContentKey: '',
                template: '',
                isPrimarySection: false,
                handlesOwnCrud: false,
                baseEndpoint: this.appSettings.API_ENDPOINTS.addOnGroup,
                sectionEndpoint: '',
                loggingService: this.loggingService,
                dataService: this.dataService,
                identityService: this.identityService,
                noun: Model.NounEnum.ServiceAddOnMappingMain
            };

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_ADDONGROUP_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new MainSection(_.extend({}, baseSectionProps, {
                    displayNameContentKey: 'SECTION_MAIN',
                    template: 'main.html',
                    isPrimarySection: true,
                    busyService: this.busyService,
                    $q: this.$q,
                    sectionSecurityKey: this.securityKeys.DATA_ADDONGROUP_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                }), this.userHasSingleBusinessType));
            }
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_ADDONGROUP_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new ServiceAddOnTimeSection(_.extend({}, baseSectionProps, {
                    sectionId: 1,
                    displayNameContentKey: 'SECTION_ADDON_TIME',
                    sectionEndpoint: `ServiceAddOnStepTime`,
                    template: 'serviceaddontime.html',
                    busyService: this.busyService,
                    handlesOwnCrud: false,
                    noun: Model.NounEnum.ServiceAddOnMappingMain,
                    sectionSecurityKey: this.securityKeys.DATA_ADDONGROUP_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                })));
            }
        }

        selectSection(item): void {
            switch (item.sectionId) {
                case 1:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_ADDONGROUP_TAB_MAIN);
                    break;
                default:
                    this.buildCrudSecurityKeysBase(this.securityKeys.DATA_ADDONGROUP_TAB_MAIN, true, true);
                    break;
            }
            super.selectSection(item);
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
        }

        isBusinessTypeSelected(): boolean {
            let model = this.selectedSection.model || {};

            return model["businessTypeDetail"] && Object.keys(model["businessTypeDetail"]).length > 0;
        }

        // Undelete override to left objectState Active after undelete
        undelete(): void {
            super.undelete(true);
        }
    }
}